import { useEffect } from 'react';
import { useAppSelector } from '@/store/hooks';

/** Applies the persisted/derived theme mode to `<html class="dark">` so Tailwind's dark: variant picks it up. */
export function ThemeSync() {
  const mode = useAppSelector((state) => state.theme.mode);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', mode === 'dark');
    document.documentElement.style.colorScheme = mode;
  }, [mode]);

  return null;
}
